import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { getRect } from './use-rect';
export var useHeight = function useHeight(element) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  useEffect(function () {
    if (element.current) {
      setHeight(getRect(element.current).height);
    }
  }, [element.current]);
  return height;
};
export default useHeight;